/** @jsxImportSource @emotion/react */
import { useEffect, useRef } from "react";

import { Interpolation, Theme } from "@emotion/react";

import lottie, { AnimationItem } from "lottie-web/build/player/lottie_light";

interface LottieAnimationProps {
  animationData: unknown;
  loop?: boolean;
  css?: Interpolation<Theme>;
  "data-testid"?: string;
}

const LottieAnimation = ({
  animationData,
  loop = true,
  ...props
}: LottieAnimationProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const animRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    animRef.current = lottie.loadAnimation({
      container: ref.current,
      animationData,
      loop,
      autoplay: true,
      renderer: "svg"
    });
    return () => animRef.current?.destroy();
  }, [animationData, loop]);

  return <div ref={ref} {...props} />;
};

export default LottieAnimation;
